<div class="box-main">
    <div class="container box-detail">
        <div class="row">
            <div class="col-md-12">
                <h1 class="sum-title1">Chi tiết đơn hàng</h1>
                <div>
                    <h2 class="sum-title2">Thông tin người mua</h2>
                    <div class="row">
                        <div class="col-md-6">
                            <span class="box-lable">Họ và tên:</span><span>{{modelSaveOrder.customerName}}</span><br>
                            <span class="box-lable">Email:</span><span>{{modelSaveOrder.email}}</span><br>
                            <span class="box-lable">Mã số thuế:</span><span>{{modelSaveOrder.taxCode}}</span><br>
                            <span class="box-lable">Tên công ty:</span><span>{{modelSaveOrder.companyName}}</span><br>
                            <span class="box-lable">Địa chỉ công
                                ty:</span><span>{{modelSaveOrder.companyAddress}}</span><br>
                        </div>
                        <div class="col-md-6">
                            <span class="box-lable">Số điện thoại:</span><span>{{modelSaveOrder.phone}}</span><br>
                            <span class="box-lable">Địa chỉ nhận
                                hàng:</span><span>{{modelSaveOrder.deliveryAddress}}</span><br>
                            <span class="box-lable">Tỉnh/Thành
                                phố:</span><span>{{modelSaveOrder.provinceName}}</span><br>
                            <span class="box-lable">Quận/Huyện:</span><span>{{modelSaveOrder.districtName}}</span><br>
                            <span class="box-lable">Phường/Xã:</span><span>{{modelSaveOrder.wardName}}</span><br>
                            <span class="box-lable">Ghi chú:</span><span>{{modelSaveOrder.note}}</span><br>
                        </div>
                    </div>
                </div>

                <div>
                    <h2 class="sum-title2">Thông tin đơn hàng</h2>
                    <div class="package-info">
                        <div class="col-md-12 sum-pkg-code">
                            <i class="fa fa-file-text-o font-size-24" aria-hidden="true"></i>
                            <span class="pl-1">Mã đơn hàng:</span>
                            <span class="pl-1">{{modelSaveOrder.orderCode}}</span>
                        </div>
                        <div class="col-md-12 pkg-group">
                            <div class="pkg-group-content-status">
                                <div>
                                    <ul class="pkg-status-timeline">
                                        <li>
                                            <div class="active">
                                                <span>{{modelSaveOrder.orderDate}}</span>&nbsp;&nbsp;
                                                <span>Đơn hàng đã đặt/Chờ tiếp nhận</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 pkg-group-detail">
                            <div class="col-md-12 pkg-group-content-detail">
                                <div class="pkg-group-content-detail-header">
                                    <div>
                                        <p style="font-size: 20px;">Chi tiết đơn hàng</p>
                                    </div>

                                    <div class="pkg-setup-info">
                                        <p>Đơn hàng của bạn được vận chuyển bởi Viettel Post kèm tài liệu hướng dẫn sử
                                            dụng
                                            và hướng dẫn lắp đặt</p>
                                    </div>
                                </div>
                                <table class="table table-bordered table-striped table-package-list"
                                    *ngIf="modelSaveOrder.listPackage.length > 0">
                                    <thead>
                                        <tr>
                                            <th class="text-center">Thông tin gói cước</th>
                                            <th class="text-center">Số lượng</th>
                                            <th class="text-center">Đơn giá</th>
                                            <th class="text-center">Thành tiền</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="package-list" *ngFor="let item of modelSaveOrder.listPackage">
                                            <td>
                                                <span *ngIf="item.packageCode.startsWith('HD_TN')">{{item.packageName}}
                                                    {{item.packageCode}}</span>
                                                <span *ngIf="item.packageCode.startsWith('HD_TC')">{{item.packageName}}
                                                    {{item.packageCode}}</span>
                                                <br><small>({{item.packageName}})</small>
                                            </td>
                                            <td class="text-center">{{item.quantity | number}}</td>
                                            <td class="text-right">
                                                {{item.packagePrice | number}} vnđ
                                            </td>
                                            <td class="text-right">
                                                <span>{{item.amount | number}} vnđ</span>
                                            </td>
                                        </tr>
                                        <tr class="package-list sum-pkg-total">
                                            <td colspan="3" class="text-right font-weight-bold">Tổng số lượng</td>
                                            <td class="text-right font-weight-bold">{{total | number}}</td>
                                        </tr>
                                        <tr class="package-list sum-pkg-total">
                                            <td colspan="3" class="text-right font-weight-bold">Tổng tiền hàng</td>
                                            <td class="text-right font-weight-bold" style="color: red;">
                                                <span>{{totalOrderAmount | number}}</span> vnđ</td>
                                        </tr>
                                        <tr class="package-list sum-pkg-total sum-pkg-summary tbl-border-top">
                                            <td colspan="3" class="text-right font-weight-bold">Tổng chi phí đơn hàng
                                            </td>
                                            <td class="text-right font-weight-bold" style="color: red;">
                                                <span>{{totalCostOrder | number}}</span> vnđ</td>
                                        </tr>
                                        <tr class="package-list sum-pkg-total sum-pkg-summary tbl-border-top">
                                            <td colspan="3" class="text-right font-weight-bold">Hình thức thanh toán
                                            </td>
                                            <td class="text-right">
                                                <span *ngIf="modelSaveOrder.paymentMethod == 1">Thanh toán khi nhận
                                                    hàng</span>
                                                <span *ngIf="modelSaveOrder.paymentMethod == 2">Thanh toán trực tuyến
                                                    qua
                                                    ViettelPay</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</div>
<ng4-loading-spinner [threshold]="1000" [timeout]="5800" [zIndex]="9999"></ng4-loading-spinner>